import React, { useEffect } from 'react';
import {
	Container,
	Grid,
	Typography,
	TextField,
	Button,
	CircularProgress,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import useStyles from '../../styles/style';
import { useDispatch, useSelector } from 'react-redux';
import { findAccountAction } from '../../redux/actions/userAction';

const FindAccount = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	const account = useSelector(state => state.account);

	const emailSchema = Yup.object({
		emailOrPhone: Yup.string()
			.required(),
	});

	const handleSubmit = values => {
		dispatch(findAccountAction(values));
	};

	useEffect(() => {
		document.title = `${t('title')} | ${t('search-account')}`;

		if (account.status === 200) {
			sessionStorage.setItem('accountMessage', account.message);
			history.push('/success');
		}
	}, [t, account]);
	return (
		<div>
			<Container>
				<Grid
					container
					justifyContent='center'
					alignItems='center'
					style={{ height: '30vh' }}
				>
					<Grid item xs={12} sm={12} md={6}>
						<Typography variant='body1' style={{ color: '#198754' }}>
							{account.message}
						</Typography>
						<Typography variant='body1' color='error'>
							{account.error}
						</Typography>
						<Typography variant='h6'>{t('search-account-text')}</Typography>
						<Formik
							validationSchema={emailSchema}
							initialValues={{ emailOrPhone: '' }}
							onSubmit={(values, { resetForm }) => {
								resetForm({ ...values, emailOrPhone: '' });
								handleSubmit(values);
							}}
						>
							{props => (
								<Form onSubmit={props.handleSubmit}>
									<TextField
										size='small'
										margin='normal'
										variant='outlined'
										fullWidth
										label="Email or Phone"
										onChange={props.handleChange('emailOrPhone')}
										values={props.values.email}
										error={
											props.values.emailOrPhone !== '' &&
											Object.prototype.hasOwnProperty.call(
												props.errors,
												'emailOrPhone'
											)
										}
										helperText={props.values.emailOrPhone !== '' && props.errors.emailOrPhone}
									/>
									<Button
										type='submit'
										variant='contained'
										className={classes.submit}
										disabled={
											!props.values.emailOrPhone ||
											Object.keys(props.errors).length !== 0 ||
											account.loading
										}
									>
										{account.loading ? (
											<>
												<CircularProgress size={20} />
												&nbsp;
												{t('loading')}
											</>
										) : (
											t('search-account')
										)}
									</Button>
								</Form>
							)}
						</Formik>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default FindAccount;
